import { useState } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HelpCircle } from 'lucide-react'
import LanguageSwitcher from '@components/ui/LanguageSwitcher'

const LOGIN_IMAGES = Array.from({ length: 10 }, (_, i) => `/assets/login/${i + 1}.jpg`)

export default function AuthLayout() {
  const { t } = useTranslation()
  const [bgImage] = useState(() => LOGIN_IMAGES[Math.floor(Math.random() * LOGIN_IMAGES.length)])

  return (
    <div className="min-h-screen flex">
      {/* Left Side - Branding with background image */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <img
          src={bgImage}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0D1F35]/70" />
        <div className="relative z-10 p-12 flex flex-col justify-between w-full">
          <div>
            <img src="/assets/immotron-logo-light.svg" alt="Immotron" className="h-10" />
            <p className="text-white/70 mt-2">
              {t('app.tagline')}
            </p>
          </div>

          <div className="text-white/80">
            <blockquote className="text-xl italic">
              "Die beste Zeit, in Immobilien zu investieren, war vor 20 Jahren.
              Die zweitbeste Zeit ist jetzt."
            </blockquote>
            <p className="mt-4 text-white/60">— Immotron</p>
          </div>

          <div className="text-white/50 text-sm">
            © {new Date().getFullYear()} Immotron · Uniplacement GmbH. Alle Rechte vorbehalten.
          </div>
        </div>
      </div>

      {/* Right Side - Auth Form */}
      <div className="flex-1 flex flex-col">
        {/* Language Switcher */}
        <div className="absolute top-4 right-4">
          <LanguageSwitcher />
        </div>

        {/* Content */}
        <div className="flex-1 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            {/* Mobile Logo */}
            <div className="lg:hidden text-center mb-8">
              <img src="/assets/immotron-logo.svg" alt="Immotron" className="h-8 mx-auto" />
            </div>

            <Outlet />
          </div>
        </div>

        {/* Footer with Help Link */}
        <div className="text-center pb-8 text-gray-500 text-sm flex items-center justify-center gap-4">
          <span className="lg:hidden">© {new Date().getFullYear()} Immotron · Uniplacement GmbH</span>
          <Link data-testid="auth-layout-help-link" to="/help" className="inline-flex items-center gap-1 text-gray-400 hover:text-primary-600 transition-colors">
            <HelpCircle size={14} />
            {t('publicHelp.badge', 'Hilfe')}
          </Link>
        </div>
      </div>
    </div>
  )
}
